import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";

const AddressAdmin = () => {
  useCheckAccess('AddressRO'); // Check if the user is logged in (if no user data, redirect to login)
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | முகவரி நிர்வாகி பக்கம்</title>
        <link rel="canonical" href="/address/admin" />
      </Helmet>
      <>
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <button onClick={() => navigate("/address-area/create")}>அஞ்சலை உருவாக்கு</button>

            </div>
          </div>
        </div>
        <br /><br />
      </>
      <Footer />
    </>
  );
};
export default AddressAdmin;